import { selfInstantiateOnLoad } from "../utils";
import { SubaruModalBase } from "./subaruModalBase";
export default class SubaruViewVehiclesModal extends SubaruModalBase {
    constructor() {
        super("ViewVehiclesModal", "vvm-open");
        this._openModal = (e) => {
            const trigger = e.currentTarget;
            this._modalTriggerButton = trigger;
            const category = trigger.dataset.offerCategory || "";
            const card = trigger.closest(".thumbnail");
            const vehicleName = card.querySelector(".caption h3")?.textContent?.trim() || "";
            const allIncentives = JSON.parse(card.dataset.incentives || "[]");
            const offers = allIncentives
                .filter((i) => i.cardCategories.includes(category))
                .map((i) => {
                const { highlight, highlightSub } = SubaruViewVehiclesModal.getHighlightData(category, i);
                return {
                    title: i.title,
                    highlight,
                    highlightSub,
                    text: i.text,
                    legal: i.legal,
                    inventoryUrl: i.inventoryLinkUrl,
                    endsText: i.offerEndsText,
                };
            });
            this.populateModal(vehicleName, `${category} Offers Available`, offers);
            this._showModal();
        };
        if (!this._modal)
            return;
        this._titleEl = document.getElementById("vvmTitle");
        this._subtitleEl = document.getElementById("vvmSubtitle");
        this._offerList = document.getElementById("vvmOfferList");
        this._template = document.getElementById("vvmOfferTemplate");
        this.addEventListeners();
    }
    addEventListeners() {
        const openButtons = document.querySelectorAll(".rti-card__offer-row");
        openButtons.forEach((btn) => btn.addEventListener("click", this._openModal));
    }
    static formatNumber(value) {
        const num = Number.parseFloat(value);
        if (Number.isNaN(num))
            return value;
        return num.toLocaleString(undefined, { maximumFractionDigits: 0 });
    }
    static getHighlightData(category, offer) {
        switch (category) {
            case "Lease":
                return {
                    highlight: offer.leaseMonthlyPayment
                        ? `$${SubaruViewVehiclesModal.formatNumber(offer.leaseMonthlyPayment)}`
                        : "",
                    highlightSub: "month",
                };
            case "Finance":
                return {
                    highlight: offer.apr ? `${offer.apr}% APR` : "",
                    highlightSub: offer.term ? `${offer.term} months` : "",
                };
            case "Cash":
                return {
                    highlight: offer.cash
                        ? `$${SubaruViewVehiclesModal.formatNumber(offer.cash)}`
                        : "",
                    highlightSub: "cash",
                };
            default:
                return { highlight: "", highlightSub: "" };
        }
    }
    populateModal(title, subtitle, offers) {
        this._titleEl.textContent = title;
        this._subtitleEl.textContent = subtitle;
        this._offerList.innerHTML = "";
        for (const offer of offers) {
            const clone = this._template.content.cloneNode(true);
            clone.querySelector(".vvm-offer-title").innerHTML = offer.title;
            clone.querySelector(".vvm-offer-highlight").textContent = offer.highlight;
            clone.querySelector(".vvm-offer-highlight-sub").textContent =
                offer.highlightSub;
            clone.querySelector(".vvm-offer-text").innerHTML = offer.text;
            clone.querySelector(".vvm-offer-legal").innerHTML = offer.legal;
            clone.querySelector(".vvm-offer-ends").innerHTML = offer.endsText;
            const link = clone.querySelector(".vvm-offer-inventory-link");
            if (offer.inventoryUrl) {
                link.href = offer.inventoryUrl;
            }
            else {
                link.remove();
            }
            const toggle = clone.querySelector(".vvm-legal-toggle");
            toggle.addEventListener("click", () => {
                const legal = toggle
                    .closest(".vvm-legal-wrapper")
                    .querySelector(".vvm-offer-legal");
                legal.classList.add("expanded");
                toggle.classList.add("expanded");
            });
            this._offerList.appendChild(clone);
        }
    }
    trapFocus(e) {
        const closeButton = this._modal.querySelector("[data-dismiss='modal']");
        const inventoryLinks = this._modal.querySelectorAll(".vvm-offer-inventory-link");
        const lastFocusable = inventoryLinks.length > 0
            ? inventoryLinks[inventoryLinks.length - 1]
            : closeButton;
        if (document.activeElement === lastFocusable && !e.shiftKey) {
            e.preventDefault();
            closeButton.focus();
        }
        else if (document.activeElement === closeButton && e.shiftKey) {
            e.preventDefault();
            lastFocusable.focus();
        }
    }
}
selfInstantiateOnLoad(SubaruViewVehiclesModal);
